<template>
  <list-condition-template ref="recharge" :rows="rows" :total="total" @page-info-change="handlePageInfoChange" :index-column="true">
    <template slot="condition">
      <el-form-item>
        <el-input @keyup.enter.native="handleFilter"  placeholder="联系人/手机号/公司/地址 查找" style="width: 210px" v-model="listQuery.keyword" clearable></el-input>
      </el-form-item>
            <el-form-item>
        <el-select @change="handleFilter" clearable style="margin-left: 10px; width: 150px" class="filter-item" placeholder="启用状态" v-model="listQuery.enabled">
          <el-option v-for="item in stateOptions" :key="item.name" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-left: 10px;">
        <el-button class="filter-item" type="primary" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
      </el-form-item>
    </template>
    <template slot="columns">
      <el-table-column min-width="50px" label="联系人" sortable="custom" property="contact" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.contact}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="50px" label="手机号" align="center" sortable="custom" property="mobile">
        <template slot-scope="scope">
          <span>{{scope.row.mobile}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="50px" label="公司" align="center" property="companyName">
        <template slot-scope="scope">
          <span>{{scope.row.companyName}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="100px" label="地址" align="center" property="address">
        <template slot-scope="scope">
          <span>{{scope.row.address}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="50px" label="账户余额" align="center" sortable="custom" property="balance">
        <template slot-scope="scope">
          <span>{{scope.row.balance}}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" align="center" label="启用状态" width="100px">
        <template slot-scope="scope">
          <el-tag :type="scope.row.enabled ==='YES' | showFilter">{{scope.row.enabled ==='YES' ? '启用' : '停用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="300px" class-name="fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="recharge(scope.row)" v-waves>充值</el-button>
          <el-button type="primary" size="mini" @click="refund(scope.row)" v-waves>退款</el-button>
          <el-button type="primary" size="mini" @click="balanceRecord(scope.row.id)" v-waves>余额记录</el-button>
        </template>
      </el-table-column>
    </template>
    <!-- 充值退款弹窗 -->
    <el-dialog :title="diaologTitle" class="balanceChange" :visible.sync="dialogShow" width="30%" @close="handleDialogClose" center>
      <!-- <el-divider></el-divider> -->
      <el-form size="mini" ref="balanceChange" :model="balanceChangeData" :rules="balanceChangeData.rules" label-width="120px" status-icon>
        <el-form-item label="账户余额：" prop="balance">
          <span>￥ {{balanceChangeData.balance}} 元</span>
        </el-form-item>
        <el-form-item :label="diaologTitle + '金额：'" prop="amount">
          <el-input v-model="balanceChangeData.amount" @input="oninput" :placeholder="'请输入' + diaologTitle + '金额（元）'"  show-word-limit maxlength="10" clearable></el-input>
        </el-form-item>
        <el-form-item label="操作备注：" prop="remark">
          <el-input type="textarea" placeholder="请输入操作备注（选填）" v-model="balanceChangeData.remark" :rows="5" show-word-limit maxlength="255" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:100px;" size="small" @click="dialogShow = false">取消</el-button>
        <el-button style="width:100px;margin-left:20px;" size="small" type="primary" @click="onSubmit(balanceChangeData)" :loading="balanceChangeData.loading">{{balanceChangeData.loading ? '提交中' : '确定'}}</el-button>
      </span>
    </el-dialog>

  </list-condition-template>
</template>

<script>
import rechargeApi from '@/api/customer/recharge'
import waves from '@/directive/waves' // 水波纹指令
import listConditionTemplate from '@/components/templates/listConditionTemplate'

export default {
  directives: {
    waves
  },
  components: {
    listConditionTemplate
  },
  data () {
    return {
      rows: null,
      total: 0,
      listQuery: {
        keyword: null
      },
      stateOptions: [
        {
          name: '启用',
          value: 1
        },
        {
          name: '停用',
          value: 0
        }
      ],
      dialogShow: false,
      diaologTitle: '',
      balanceChangeData: {
        balance: null,
        loading: false,
        customerId: null,
        amount: null,
        remark: null,
        rules: {
          amount: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!value || value === '' || typeof value === 'undefined') {
                  callback(new Error('请输入' + this.diaologTitle + '金额'))
                } else if (Number(value) <= 0) {
                  callback(new Error(this.diaologTitle + '金额不能小于等于0'))
                } else if (this.diaologTitle === '退款' && Number(value) > this.balanceChangeData.balance) {
                  callback(new Error('退款金额不能大于账户余额'))
                } else if (value.split('.')[0].length > 8) {
                  callback(new Error(this.diaologTitle + '金额整数部分不能超过8位'))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ]
        }
      }
    }
  },
  filters: {
    /**
     * 表格行显示状态过滤
     * @param {*} show 显示状态
     */
    showFilter (show) {
      return show ? 'success' : 'danger'
    },
    /**
     * 表格按钮显示状态过滤
     * @param {*} show 显示状态
     */
    showButtonFilter (show) {
      return !show ? 'success' : 'danger'
    }
  },
  methods: {
    oninput (e) {
      // 通过正则过滤小数点后两位
      if (e) {
        this.balanceChangeData.amount = e.match(/^\d*(\.?\d{0,2})/g)[0] || null
      }
    },
    /**
     * 加载数据
     */
    getList (pageInfo) {
      if (this.listQuery.enabled === true) {
        this.listQuery.enabled = true
      }
      rechargeApi
        .getPaged({ condition: this.listQuery, pageInfo })
        .then(response => {
          this.rows = response.data.content
          this.total = response.data.totalElements
        })
    },
    /**
     * 搜索条件变更处理
     */
    handleFilter () {
      this.$refs.recharge.changeCondition()
    },
    /**
     * 分页信息变动事件处理
     * @param  {Object} pageInfo 分页信息
     */
    handlePageInfoChange (pageInfo) {
      this.getList(pageInfo)
    },
    handleDialogClose () {
      this.$refs.balanceChange.resetFields()
    },
    /**
     * 充值
     */
    recharge (row) {
      this.balanceChangeData.customerId = row.id
      this.diaologTitle = '充值'
      this.dialogShow = true
      this.balanceChangeData.balance = row.balance
    },
    /**
     * 退款
     */
    refund (row) {
      this.balanceChangeData.customerId = row.id
      this.diaologTitle = '退款'
      this.dialogShow = true
      this.balanceChangeData.balance = row.balance
    },
    /**
     * 提交
     */
    onSubmit (data) {
      this.$refs.balanceChange.validate().then(response => {
        if (!response) {
          return
        }
        this.balanceChangeData.loading = true
        if (this.diaologTitle === '充值') {
          rechargeApi.recharge(data).then(response => {
            this.balanceChangeData.loading = false
            this.dialogShow = false
            this.$notify({
              title: '成功',
              message: `充值成功`,
              type: 'success'
            })
            this.handleFilter()
          }).catch(response => {
            this.balanceChangeData.loading = false
          })
        } else {
          rechargeApi.refund(data).then(response => {
            this.balanceChangeData.loading = false
            this.dialogShow = false
            this.$notify({
              title: '成功',
              message: `退款成功`,
              type: 'success'
            })
            this.handleFilter()
          }).catch(response => {
            this.balanceChangeData.loading = false
          })
        }
      })
    },
    balanceRecord (id) {
      this.$router.pushTo(this.$router.routesConfig.balanceRecordList, id)
    }
  },
  created () {

  }
}
</script>

